module.exports = __webpack_public_path__ + "media/images/common/lp/bg-presentAmazon-a91820e166302526991dd873f9e69d4e.png";